/**
 * Type-guard to check if the provided value is
 *
 * @param value The value to check if it is iterable.
 * @returns Wheter the provided value is iterable.
 */
export default function isIterable(value: unknown): value is Iterable<any> {
    return (
        !!value &&
        typeof value === 'object' &&
        Symbol.iterator in value &&
        typeof value[Symbol.iterator] === 'function'
    );
}
